const { trackDownload } = require('../../../../js/functions');

const SELECTOR_TITLE = '.press-release-details-widget--title';
const SELECTOR_BUTTON = '.press-release-details-widget--button';

module.exports = {
	init() {
		this.title = this.root.querySelector(SELECTOR_TITLE);
		this.downloadBtn = this.root.querySelector(SELECTOR_BUTTON);
		this.initEvents();
	},
	initEvents() {
		if (this.title && this.downloadBtn) {
			this.downloadBtn.addEventListener('click', () => {
				trackDownload(this.title.textContent, this.downloadBtn.href);
			});
		}
	},
};
